import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/axios';

export function useFactors(filters = {}) {
  const params = new URLSearchParams();
  if (filters.category) params.set('category', filters.category);
  if (filters.page_type) params.set('page_type', filters.page_type);
  if (filters.impact) params.set('impact', filters.impact);
  if (filters.search) params.set('search', filters.search);
  if (filters.enabled !== undefined) params.set('enabled', filters.enabled);
  const qs = params.toString();

  return useQuery({
    queryKey: ['factors', qs],
    queryFn: async () => {
      const { data } = await api.get(`/factors${qs ? '?' + qs : ''}`);
      return data;
    },
  });
}

export function useFactorStats() {
  return useQuery({
    queryKey: ['factors-stats'],
    queryFn: async () => {
      const { data } = await api.get('/factors/stats');
      return data;
    },
  });
}

export function useUpdateFactor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, ...payload }) => {
      const { data } = await api.patch(`/factors/${id}`, payload);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['factors'] });
      qc.invalidateQueries({ queryKey: ['factors-stats'] });
    },
  });
}

export function useCreateFactor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload) => {
      const { data } = await api.post('/factors', payload);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['factors'] });
      qc.invalidateQueries({ queryKey: ['factors-stats'] });
    },
  });
}

export function useDeleteFactor() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { data } = await api.delete(`/factors/${id}`);
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['factors'] });
      qc.invalidateQueries({ queryKey: ['factors-stats'] });
    },
  });
}
